<template>
  <div class="content">
    <div>
      <div class="title" :title="data.contentTitle">{{ data.contentTitle }}</div>
      <div class="desc">
        <div>{{ data.createTime }} 来源: {{ data.releaseName }}</div>
        <div>
          字号:
          <span @click="() => checkFocus(0)" :class="returnFocus(0)">大</span>
          <span @click="() => checkFocus(1)" :class="returnFocus(1)">中</span>
          <span @click="() => checkFocus(2)" :class="returnFocus(2)">小</span>
        </div>
      </div>
      <div
        :class="
          open
            ? data.fileList.length == 0
              ? `html-content html-height design-html no-file`
              : `html-content html-height design-html`
            : `html-content design-html`
        "
        v-html="data.contentHtml"
        :style="size ? `font-size: ${size};` : ''"
      ></div>
      <div
        v-show="open"
        class="file-list"
        v-for="item in data.fileList"
        @click="down(item.fileCode)"
        :key="item"
      >
        <img src="../../../assets/images/矩形 3.png" alt="文件图标" />
        <span>{{ item.fileName }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getFileDetails, downloadFile } from "@/api/file.js";
export default {
  name: "content",
  props: {
    data: {
      type: Object,
      default: {},
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      focus: 1,
      size: "18px",
    };
  },
  computed: {
    returnFocus: function () {
      const self = this;
      return function (val) {
        return self.focus === val && "focus";
      };
    },
  },
  methods: {
    down(filecode) {
      getFileDetails(this.data.appCode, this.data.tenantCode, [filecode]).then(
        (res) => {
          const obj = this._.get(
            Object.values(this._.get(res, "data", {})),
            "0",
            {}
          );
          // let baseUrl = process.env.NODE_ENV === 'development' ? 'http://10.11.0.104:55000' : 'http://10.10.152.115:55000'
          downloadFile(
            `/api/cloud-fastdfs/fastdfs/download/file/${this.data.tenantCode}/${this.data.appCode}?fileCode=${obj.fileCode}`,
            obj.fileName
          );
        }
      );
    },
    checkFocus(val) {
      const obj = {
        0: "22px",
        1: "18px",
        2: "14px",
      };
      this.focus = val;
      this.size = obj[val];
    },
  },
};
</script>

<style scoped lang="less">
.content {
  /* height: 600px; */
  background: white;
  position: relative;
  text-align: center;
  > div {
    display: inline-block;
    width: 100%;
    padding: 0 50px;
    background: white;
  }
}
.title {
  text-align: center;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 41px;
  margin-top: 12px;
  height: 41px;
   white-space: nowrap;
  overflow: hidden;
  text-overflow:ellipsis;
}
.desc {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eeeeee;
  > div:nth-of-type(1) {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #bcbec0;
    line-height: 60px;
  }
  > div:nth-of-type(2) {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #7f7f7f;
    line-height: 60px;
    > span {
      color: #333333;
      margin-right: 5px;
      padding: 0 3px;
      cursor: pointer;
    }
    > span.focus {
      border: 1px solid #cab484;
      color: #cab484;
    }
  }
}
/deep/.html-content {
  margin-top: 23px;
  margin-bottom: 90px;
  text-align: left;
  // text-indent: 2em;
  // line-height: 34px;
  height: 420px !important;
  overflow: hidden;
  text-align: justify;
  text-justify: inter-ideograph;
}
/deep/.no-file {
  height: 528px !important;
  margin-bottom: 8px !important;
}
.html-height {
  height: auto;
  overflow: auto;
}
.file-list {
  text-align: left;
  margin-bottom: 12px;
  cursor: pointer;
  img {
    width: 24px;
    height: 24px;
    margin-right: 11px;
  }
  span {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    text-decoration: underline;
    color: #bda26d;
    line-height: 40px;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content/officeService/siderContent-01.vue